<template>
  <div class="error-container">
    <div class="error-main">
      <img src="../assets/images/zujuan_404.png" alt="error" />
      <p class="error-tips">据《关于进一步减轻义务教育阶段学生作业负担和校外培训负担》的相关规定，自2021年8月27日起，教习网不再提供搜题组卷服务。</p>
      <p class="error-text">原付费充值的组卷VIP用户可联系客服办理退款事宜</p>
      <el-button type="primary" class="back-btn">
        <a :href="`${$data.$BASE_URL}`">返回首页</a>
      </el-button>
    </div>
  </div>
</template>

<script>
var that
import { $BASE_URL } from '../utils/env'
export default {
  name: 'error',
  data() {
    return {
      $BASE_URL: $BASE_URL.replace('api', ''),
    }
  },
  created() {
    that = this
  },
  mounted() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.error-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .back-btn {
    width: 128px;
    margin-top: 20px;
    a {
      color: #fff;
    }
  }
  & > .error-main {
    box-sizing: border-box;
    width: 1200px;
    min-width: 1200px;
    min-height: 600px;
    margin: 20px auto 100px;
    padding: 65px 100px;
    background-color: #fff;
    text-align: center;
    .error-tips {
      font-size: 16px;
      color: #333;
      width: 500px;
      text-align: center;
      margin: 10px auto;
      line-height: 24px;
    }
    .error-text {
      font-size: 14px;
      color: #999;
    }
  }
}
</style>
